//@flow
import * as React from 'react'
import {Field} from 'redux-form'
import WrapCheckbox from '../common/WrapCheckbox'
import type { SimpleMultiAnswersQuestion$Props } from './flowTypes'

const SimpleMultiCheckbox=({field,label})=>{
    return (
        <div className='row'>
            <div className='col-sm'>
                 <Field 
                    name={field}
                    component={WrapCheckbox}
                    label={label}
                />
            </div>
        </div>
    )
}

const SimpleMultiAnswersQuestion=(props:SimpleMultiAnswersQuestion$Props)=>{
    let checkboxes = []
    props.answers.map(answer=>{
        checkboxes.push(<SimpleMultiCheckbox key={answer.field} field={answer.field} label={answer.label} />)
    })

    return (
        <div className='container'>
            {checkboxes}
        </div>
    )
}

export default SimpleMultiAnswersQuestion


// WEBPACK FOOTER //
// ./src/components/QualityReview/SimpleMultiAnswersQuestion.js